<template>
    <div>
         <span class="fa fa-circle"
               :class="{'text-success': (value.id !== '' && value.hasOwnProperty('id')), 'text-danger': (value.id === '' || !value.hasOwnProperty('id'))}"
               style="position: absolute; right: 25px; font-size: 10px; transform: translateY(5px); cursor: pointer;"></span>
        <span @click="clearValue" class="fa fa-times text-danger"
              style="position: absolute; right: 10px; transform: translateY(5px); cursor: pointer;"></span>
        <input class="form-control" placeholder="" :data-name="name" @input="onSearch" @paste="onPaste" :value="value[label]"/>
        <ul v-if="items.length > 0" class="list-group"
            style="height: 250px; overflow: scroll; background: #d0d2d0; min-width: 200px; padding: 0px; z-index:11000">
            <li class="list-group-item p-2 bg-dark" v-for="(item, i) in items" :key="i" @click="onSelected(item)">
                {{ item[label] != undefined ? item[label] : '' }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "SelectSearchCustom",
    props: {
        item: {
            type: Object,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: 'label',
        },
        index: {
            type: Number,
            default: 0,
        },
        exact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            items: [],
            value: {
                "id": "",
                "label": ""
            },
            empty: false,
            operator: '?',
        };
    },
    watch: {
        value: {
            handler(val) {
                if (this.suppressEmit) return;
                if (val && val.hasOwnProperty('id') && val.id !== "") {
                    this.$emit("onSelect", val, this.index);
                }
            },
            deep: true
        }
    },
    methods: {
        onSelected(item) {
            this.items = [];
            this.value = item;
            sessionStorage.setItem(`cs${this.index}-${this.name}`, JSON.stringify(item));

            this.$emit("onSelect", item, this.index);
        },
        async onPaste(event){
            const pastedData = event.clipboardData.getData('text');
            let options = []
            await axios.get(this.item.option.search.route + `?exact=${this.exact ? 1 : 0}&field=${this.item.option.search.field ? this.item.option.search.field: ''}&search=` + pastedData)
                .then(res => {
                    options = res.data;
                }).catch(err => {
                    console.error(err)
                });

            this.value[this.label] = event.target.value;
            this.items = options;
            this.value[this.label] = event.target.value;
            this.$forceUpdate()
        },
        async onSearch(event) {
            var keypressed = event.which || event.keyCode;
            if (keypressed === 8 // backspace
              //  || keypressed === 27 // escape
                || keypressed === 46 // delete
                || (keypressed >= 35 && keypressed <= 40) // end, home, arrows
                || event.ctrlKey || event.metaKey) {
                return;
            }

            const newValue = event.target.value + event.key;


            if (newValue.trim().toLowerCase() === 'v') {
                return;
            }

            let options = []
            let keyEvent =  ''
            if (event.key !== undefined){
                keyEvent = event.key
            }
            await axios.get(this.item.option.search.route + `?exact=${this.exact ? 1 : 0}&field=${this.item.option.search.field ? this.item.option.search.field: ''}&search=` + event.target.value + keyEvent)
                .then(res => {
                    options = res.data;
                }).catch(err => {
                    console.error(err)
                });

            this.value[this.label] = event.target.value;
            this.items = options;
            this.value[this.label] = event.target.value;

            this.$forceUpdate()


        },
        async getItem(id) {
            let route = this.item.option.search.route.replace('list-of-choices', 'show-choice') + '/' + id
            if (this.item.option.search.field){
                route += "?field=" + this.item.option.search.field
            }
            let result  =  await axios.get(route)
            return result.data;
        },
        resetValue() {
            this.value = {
                [this.label]: "",
            };
        },
        setValue(value) {
            this.value = value
        },
        clearValue() {
            sessionStorage.removeItem(`cs${this.index}-${this.name}`);
            this.value = {
                "id": "",
                "label": ""
            }
            // Não emite onSelect ao limpar para evitar filtros automáticos
        }

    },
    async mounted() {
        this.value = {
            [this.label]: "",
        };
        let app = this;
        let data = sessionStorage.getItem(`cs${this.index}-${this.name}`);
        // Evita emitir seleção ao inicializar/restaurar
        this.suppressEmit = true;
        if (data !== undefined && data !== null && data !== "") {
            this.value = JSON.parse(data)
        } else if (this.item.value.equals !== undefined && this.item.value.equals !== null && this.item.value.equals !== "") {
            let item  = await this.getItem(this.item.value.equals)
            this.items = [];
            this.value = item;
        }
        this.suppressEmit = false;

    },
};
</script>
<style scoped>
ul {
    position: absolute;
    z-index: 1000;
    /*width: 100%;*/
}

li {
    cursor: pointer;
    color: white;
}

li:hover {
    background-color: #f4f4f4;
}
</style>

